import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import LayoutMixin from '@/views/dashboard/mixins/layout';

let cellular_device_template = `
<div class="panel panel-default">
    <div class="panel-body">
        <h5 class="title upper"><strong>unique cellular devices</strong></h5>
        <div class="med-stat text-center">
             <span class="text-large"><span class="fa fa-microchip"></span> {{connections}}</span>
        </div>
        <div class="balance-module-footer">
            <small>This reflects the count of unique cellular devices online this calendar month.</small>
        </div>
    </div>
</div>`;


    function formatBytes(bytes, decimals) {
        if (bytes === 0) return { value: 0, unit: 'bytes'};
        var k = 1024; // or 1024 for binary
        var dm = decimals;
        var sizes = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        var value = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
        return {
            value: value,
            unit: sizes[i]
        };
    }


    var CellularDevicesWidget = Marionette.View.extend(LayoutMixin).extend({
        className: function(){ return "account widget " + this.getWidth(); },
        ui: {
            tooltips: '[data-toggle="tooltip"]',
        },
        template: Handlebars.compile(cellular_device_template),
        modelEvents: {
            'add': 'render'
        },
        onAttach: function(){
            this.model.cellcount.fetch()
            .then( ()=>{ this.render(); } );
        },
        onRender: function(){
            this.ui.tooltips.tooltip();
        },
        templateContext: function() {
            var payment = this.options.payment_data.attributes || {};
            var billing_parameters = this.model.billing_parameters || 0;
            return {
                connections: this.model.cellcount.get('count') || 0,
                billing_parameters : billing_parameters,
                cell_conn_cost: billing_parameters.cell_conn_cost,
                cell_connect_gain : formatBytes(payment.billing_parameters.cell_conn_bandwidth_gain, 1)
            };

        }

    });

    export default CellularDevicesWidget;






